import {useDispatch, useSelector} from "react-redux";
import {dialogs, hideChangeVulTargetsDialog, loading, extendedOrganization} from "../../../store/slice";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Button, TextField} from "@mui/material";
import {useEffect, useState} from "react";
import {LocalSpinner} from "../../../../../../shared/components/Spinner";
import {UpdateAvailableVulTargetsCounter} from "../../../store/actions";

export const UpdateVulTargetsCounter = () => {
    const dispatch = useDispatch();
    const {changeOrgVulTargetsDialog: {isOpen}} = useSelector(dialogs);
    const org = useSelector(extendedOrganization);
    const {isLoadingChangeVulTargetsCount} = useSelector(loading);
    const [counter, setCounter] = useState<number>(0);

    const handleClose = () => {
        dispatch(hideChangeVulTargetsDialog());
        setCounter(0);
    };

    const handleUpdate = () => {
        if(org){
            dispatch(UpdateAvailableVulTargetsCounter({id: org.id, newValue: counter}));
            setCounter(0);
        }
    }

    useEffect(() => {
        if(isOpen && org){
            setCounter(org.configuration.availableTargetsVulnerabilityScan);
        }
        // eslint-disable-next-line
    }, [isOpen]);

    return(
        <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth={'xs'}>
            <DialogTitle>Available Vulberability scanner targets counter</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Set count below
                </DialogContentText>
                <TextField
                    type={'number'}
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Targets counter"
                    fullWidth
                    variant="standard"
                    value={counter}
                    onChange={(e) => {setCounter(parseInt(e.target.value))}}
                />
            </DialogContent>
            {isLoadingChangeVulTargetsCount.isLoading ?
                <LocalSpinner />
                :
                <DialogActions>
                    <Button onClick={handleClose} color={'warning'}>Cancel</Button>
                    <Button onClick={handleUpdate} disabled={!org || (org && org.configuration.availableTargetsVulnerabilityScan === counter)} color={'success'}>Update</Button>
                </DialogActions>
            }
        </Dialog>
    )
}